export enum CompanyEvents {
  SITE_DBL_CLICK = 'siteDblClick'
}
